import React, { useState } from 'react'
import styled from 'styled-components'
import cn from 'classnames'
import { useMediaPredicate } from 'react-media-hook'
import { Button } from 'primereact/button'

import Text from '../../../ui/Text'
import ConditionalWrapper from '../../../common/components/ConditionalWrapper'
import storage from '../../../common/utils/storage'
import useText from '../../../common/hooks/useText'

const SInfoBlock = styled.div`
    transform: translate(0, 0);
    letter-spacing: 1%;
    background-color: white;
    color: black;
    position: fixed;
    z-index: 400;
    top: 0;
    height: 100%;
    width: 480px;
    left: -480px;
    overflow-x: hidden;
    transition: left 0.25s ease-in-out;

    padding: 120px 30px;

    &.open {
        left: 0;
        transition: left 0.25s ease-in-out;
        overflow-y: hidden;
    }

    display: flex;
    flex-direction: column;
    gap: 18px;
`

export const SHeader = styled.div`
    font-size: 1.25rem;
    align-items: center;
    line-height: 28px;
`

export const SBody = styled.div`
    font-weight: var(--font-weight-light);
    font-size: 1.25rem;
    line-height: 28px;
`
const PARTNER_SIGN_IN_INFO_WAS_READ = 'partnerSignInInfoWasRead'

export const PartnerSignInInfoBlock = () => {
    const text = useText()
    const isMobileScreen = useMediaPredicate('(max-width: 990px)')
    const [isOpened, setIsOpened] = useState<boolean>(() => !storage.getItem<boolean>(PARTNER_SIGN_IN_INFO_WAS_READ))

    const onClose = () => {
        storage.setItem(PARTNER_SIGN_IN_INFO_WAS_READ, true)
        setIsOpened(false)
    }

    return (
        <ConditionalWrapper
            condition={!isMobileScreen}
            wrapper={(children) => <SInfoBlock className={cn({ open: isOpened })}>{children}</SInfoBlock>}
        >
            {isOpened && (
                <div className={cn(isMobileScreen && 'p-5', 'bg-white text-black w-full h-full flex flex-column')}>
                    <SHeader>
                        <Text code="msgPartnerSignInInfoBlockHeader" />
                    </SHeader>
                    <SBody>
                        <Text code="msgPartnerSignInInfoBlockBody" />
                    </SBody>
                    <SHeader>
                        <Text code="msgPartnerSignInInfoBlockPricingHeader" />
                    </SHeader>
                    <SBody>
                        <Text code="msgPartnerSignInInfoBlockPricingBody" />
                    </SBody>
                    <div
                        className={cn(
                            isMobileScreen ? 'flex justify-content-center my-6' : 'absolute left-0 bottom-0 mb-6 ml-6'
                        )}
                    >
                        <Button
                            type="button"
                            label={text('btnClose')}
                            onClick={onClose}
                            outlined
                            icon="pi pi-times"
                            data-testid="info-block-close-btn"
                        />
                    </div>
                </div>
            )}
        </ConditionalWrapper>
    )
}
